import React from 'react';

const CTASection = () => {
  return (
    <section className="relative z-10 -mb-[8rem] px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-[1320px]">
        <div className="bg-[#041C77] text-white font-poppins rounded-2xl shadow-lg overflow-hidden">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
            {/* Left Content */}
            <div className="w-full md:w-2/3 p-6 md:p-8 lg:p-12">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
                Find your <span className="text-white">dream home today!</span>
              </h2>
              <div className="space-y-3">
                <p className="text-sm sm:text-[15px] text-white/90">
                  Discover your perfect property with our expert guidance and personalized service.
                </p>
                <p className="text-sm sm:text-[15px] text-white/90">
                  Let us help you navigate the real estate market and find the home of your dreams.
                </p>
              </div>
            </div>

            {/* Right side */}
            <div className="w-full md:w-1/3 md:self-stretch flex items-center justify-center  md:p-0">
              <img
                src="assets/images/ctaimage.png"
                alt="City illustration"
                className="w-full max-w-[400px] md:max-w-[400px] h-[187px] object-cover rounded-lg md:rounded-none md:rounded-l-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


export default CTASection;